export class CaseAction {
    actionTypeId: number;
    actionId: number;
    notes: any;
    caseId: number;
    remarks: string;
    agencyId: number;
    caseActionId: number;
}
